/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PanelInputs */

const cs_enum_panel = /** @type {(inputs: Enum_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel`)
};

const en_enum_panel = /** @type {(inputs: Enum_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel`)
};

/**
* | output |
* | --- |
* | "Panel" |
*
* @param {Enum_PanelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_panel = /** @type {((inputs?: Enum_PanelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PanelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_panel(inputs)
	return cs_enum_panel(inputs)
});